import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { wfRun, prerequisite } from '../../../util/common-utils';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent implements OnInit {

  /****************** Variable declaration ******************/
  title: string; //title to display in dialog box
  message: string; //message to display in dialog box
  markDownData: string | undefined = ''
  dataSource: any;
  page: string;
  wfType: any;

  // Workflow run more details dialog box table properties
  /** Table details */
  dynamicColumnsToDisplay: string[];
  dynamicColumnHeaders: string[];

  /**columns to display when the workflow type is event */
  columnsToDisplay: string[] = ["workTicketId", "event", "commit", "branch", "triggeredOn", "author", "duration", "status"];
  columnHeaders: string[] = ["Work ticket", "Event", "Commit details", "Branch", "Triggered on", "Author", "Duration", "Status"];

  /**columns to display when the workflow type is manual */
  columnsToDisplayManualTrigger: string[] = ["wfName", "wfhFile", "triggeredOn", "duration", "status"];
  columnHeadersManualTrigger: string[] = ["Name", "File path", "Triggered on", "Duration", "Status"];

  /**
   * Constructor
   * @param dialogRef
   * @param data
   */
  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel | any,
    @Inject(MAT_DIALOG_DATA) public wfRunData: WfRunDialogModel | any) {
    /** Update view with given values */
    this.title = data?.title;
    this.message = data?.message;
    this.markDownData = data?.markDownData;
    this.page = this.wfRunData?.page;
    this.dataSource = this.wfRunData?.data;
    this.wfType = this.wfRunData?.wfType;
  }

  /**
   * Check if standard confirmation dialog should be displayed
   * Returns true when it's not a page tour, not an auth dialog, and not a special page type
   */
  get shouldShowStandardDialog(): boolean {
    const specialPages = [wfRun, prerequisite];
    return !this.data?.isPageTour &&
      !this.data?.isAuth &&
      !specialPages.includes(this.page);
  }

  /** ngOnInit */
  ngOnInit() {
    this.switchTable();
  }

  /** Close the dialog, return true */
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  /** Close the dialog, return false */
  onDismiss(): void {
    this.dialogRef.close(false);
  }

  /** switch column headers and column data to app-table-normal */
  switchTable() {
    this.dynamicColumnsToDisplay =
      this.wfType === "manual" ? this.columnsToDisplayManualTrigger : this.columnsToDisplay;

    this.dynamicColumnHeaders =
      this.wfType === "manual" ? this.columnHeadersManualTrigger : this.columnHeaders;
  }
}

/**    
 * Class to represent confirm dialog model.
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(public title: string, public message: string) {
  }
}

/**    
* Class to represent confirm dialog model.
* It has been kept here to keep it as part of shared component.
*/
export class WfRunDialogModel {
  constructor(public page: string, public data: any, public wfType: any) {
  }
}
